export default __webpack_public_path__ + "static/media/WaterAITool-1.0.2-setup_매뉴얼_환경.68c3ab76.zip";